"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRawLog = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const launchpad_1 = require("@cosmjs/launchpad");
function parseRawLog(input = "[]") {
    const logsToParse = JSON.parse(input).map(({ events }, i) => ({
        msg_index: i,
        events,
        log: "",
    }));
    return launchpad_1.logs.parseLogs(logsToParse);
}
exports.parseRawLog = parseRawLog;
//# sourceMappingURL=logs.js.map